import {environment} from 'src/environments/environment';

export const keycloakConfig = environment.keycloakConfig;
